import { withTranslate } from 'i18n/utils'
import featureToggles from 'shared/featureToggles'
import { DELIVERY_HOME } from 'purchase-flow/constants'

import { CardSection } from '@components/CardSection'
import Button from '@components/Button'
import Icon from '@components/Icon'
import MessageBox, { MSG_WARNING } from '@components/MessageBox'

import { ProductWithRates } from './ProductWithRates'

import styles from './styles.module.scss'

const DeliverySelectionHelper = ({
    prd,
    isAddressFilled,
    selectedDeliveryRate,
    selectDeliveryRate,
    showForm,
    setShowForm,
    deliveryAddress,
}) => {
    const shouldRenderProductsWithRates = prd => featureToggles.showAllExceptCanada || prd.prdctCd !== DELIVERY_HOME

    if (!showForm && prd.prdctCd === DELIVERY_HOME && !isAddressFilled(deliveryAddress)) {
        return (
            <CardSection notActive className="px-3 py-3 mt-3">
                <div className="d-sm-flex justify-content-between">
                    <div className="d-flex flex-column">
                        <span className="font-weight-bold">{prd.prdctName}</span>
                        <div className="text-red text-small align-items-center d-flex">
                            <span className="mr-1">
                                <Icon type="warning-triangle" />
                            </span>
                            <T>booking.monthly.missing-address-error</T>
                        </div>
                    </div>
                    <Button className="mt-2 mt-sm-0" size="small" btnStyle="outline" onClick={() => setShowForm(true)}>
                        <T>booking.monthly.add-address</T>
                    </Button>
                </div>
            </CardSection>
        )
    }

    if (shouldRenderProductsWithRates(prd)) {
        return (
            <ProductWithRates
                selectedRate={selectedDeliveryRate}
                prd={prd}
                selectRate={rate => selectDeliveryRate(rate, prd.prdctCd)}>
                {prd.prdctCd === DELIVERY_HOME && (
                    <MessageBox type={MSG_WARNING} className={styles.messageBox}>
                        <T>subscription.purchase.mail.info</T> (
                        <a
                            className="font-weight-bold"
                            href={`mailto: ${withTranslate('subscription.purchase.main.address')}`}>
                            <T>subscription.purchase.main.address</T>
                        </a>
                        ).
                    </MessageBox>
                )}
            </ProductWithRates>
        )
    }

    return null
}

export default DeliverySelectionHelper
